/**
 * Custom UIMessageChunk types used for streaming data to the frontend.
 * These extend the Vercel AI SDK's `data-${string}` pattern with type-safe values.
 */
export enum UIChunkType {
  DataFile = 'data-file',
  DataStatus = 'data-status',
  DataThought = 'data-thought',
  DataTrace = 'data-trace',
  DataCta = 'data-cta',
  DataQuestion = 'data-question',
  DataNavigate = 'data-navigate',
  DataCitation = 'data-citation',
  DataApproval = 'data-approval',
  DataQuotaWarning = 'data-quota-warning',
  DataResult = 'data-result',
  DataDegraded = 'data-degraded',
}

/**
 * Inner `data.type` discriminant inside each UIMessageChunk's data envelope.
 * Mirrors UIChunkType without the `data-` prefix — the two must stay in sync.
 */
export enum CustomEventDataType {
  File = 'file',
  Status = 'status',
  Thought = 'thought',
  Trace = 'trace',
  Cta = 'cta',
  Question = 'question',
  Navigate = 'navigate',
  Citation = 'citation',
  Approval = 'approval',
  QuotaWarning = 'quota-warning',
  Result = 'result',
  Degraded = 'degraded',
}
